import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import moment from 'moment-timezone';
import GeneralFinancialOverview from '../../components/financial/GeneralFinancialOverview';
import BranchFinancialOverview from '../../components/financial/BranchFinancialOverview';


const FinancialDashboard = () => {

  const [isLoading, setIsLoading] = useState(false);
  const [branches, setBusinessBranches] = useState([]);
  const [branchesCopy, setBusinessBranchesCopy] = useState([]);

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [hasAuthCode, setAuthCode] = useState(false);
  const [reportGenerated, setReportGenerated] = useState(false);
  const [currentXhr, setCurrentXhr] = useState(false);
  const [onlyFranchise, setOnlyFranchiseState] = useState(false);

  let isFirstOrSecondDayOfMonth = moment().date() === 1 || moment().date() === 2;
  //console.log('isFirstOrSecondDayOfMonth', isFirstOrSecondDayOfMonth);
  var rangeStartDate = isFirstOrSecondDayOfMonth ? moment().subtract(1, 'days') : moment().startOf('month'),
    rangeEndDate = moment().subtract(1, 'days');

  const [filterData, setFilterData] = useState({
    startDate: rangeStartDate.format('YYYY-MM-DD 00:00:00.000'),
    endDate: rangeEndDate.format('YYYY-MM-DD 00:00:00.000')
  })
  const interval = useRef(null);

  const [currentTab, setCurrentTab] = useState('financial-dashboard-results-tab');

  const initData = () => {
    let userProfileResponse = { ...window._sessionData };
    if (!Array.isArray(userProfileResponse.businessBranches)) {
      userProfileResponse.businessBranches = Object.keys(userProfileResponse.businessBranches).map((key) => {
        return userProfileResponse.businessBranches[key];
      });
    }
    setBusinessBranches(userProfileResponse.businessBranches);
    setBusinessBranchesCopy(userProfileResponse.businessBranches);
    clearInterval(interval.current);


    $('input[name="daterange"]').daterangepicker({
      opens: 'left',
      startDate: rangeStartDate,
      endDate: rangeEndDate,
      opens: "right",
      drops: "down",
      locale: window._sessionData.i8nDateRangePicker,
      ranges: {
        'Hoje': [moment().startOf('day'), moment().endOf('day')],
        'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Amanhã': [moment().add(1, 'days'), moment().add(1, 'days')],
        'Últimos 7 Dias': [moment().subtract(6, 'days'), moment()],
        'Últimos 30 Dias': [moment().subtract(29, 'days'), moment()],
        'Este Mês': [moment().startOf('month'), moment().endOf('month')],
        'Último Mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
    }, function (start, end, label) {
      //console.log('setFilterData', 'setFilterData');
      setFilterData({
        startDate: start.format('YYYY-MM-DD 00:00:00.000'),
        endDate: end.format('YYYY-MM-DD 00:00:00.000')
      })
    });
  }

  React.useEffect(() => {
    interval.current = setInterval(() => {
      if (window._sessionData.businessBranches && branches.length === 0) {
        initData();
      }
    }, 1000);
  }, []);

  useEffect(() => {
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('nav-link')) {
        setCurrentTab(e.target.id);
        //console.log('current tab: ', e.target.id);
      }
    });

    return () => {
      document.removeEventListener('click', function (e) {
        if (e.target.classList.contains('nav-link')) {
          setCurrentTab(e.target.id);
        }
      });
    }
  }, []);

  const setOnlyFranchise = (value) => {
    if (value) {
      setBusinessBranches(branchesCopy.filter((branch) => branch.FRANQUIADO === 1 && branch.ATIVO === 1));
      setOnlyFranchiseState(true);
    } else {
      setBusinessBranches(branchesCopy.filter((branch) => branch.FRANQUIADO === 0 && branch.ATIVO === 1));
      setOnlyFranchiseState(false);
    }
  }

  console.log('branches', branches);
  console.log('FinancialDashboard onlyFranchiseState', onlyFranchise);

  return (
    <>
      <div className="form-check form-switch">
        <input className="form-check-input" type="checkbox" role="switch" id="js-only-franchise" onChange={(e) => setOnlyFranchise(e.target.checked)} />
        <label className="form-check-label" htmlFor="js-only-franchise">Apenas Franquias</label>
      </div>
      <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
        <li key={`opts-0`} className="nav-item" role="presentation">
          <button className="nav-link active" id="financial-dashboard-results-tab" data-bs-toggle="pill" data-bs-target="#financial-dashboard-results" type="button" role="tab" aria-controls="financial-dashboard-results" aria-selected="true">Resultados</button>
        </li>
        {branches.length > 0 && branches.map((branch, index) => {
          console.log('branch.FILIAL', branch.FILIAL);
          console.log('branch.FILIAL.replace(/ /g, "-")', branch.FILIAL.replace(/ /g, "-"));
          console.log('branch.FILIAL.replace(/\./g, "-")', branch.FILIAL.replace(/\./g, "-"));
          return (
            <li key={`opts-${index + 1}`} className="nav-item" role="presentation">
              <button className="nav-link" id={branch.FILIAL.replace(/ /g, "-").replace(/\./g, "-") + '-tab'} data-bs-toggle="pill" data-bs-target={`#${branch.FILIAL.replace(/ /g, "-").replace(/\./g, "-")}`} type="button" role="tab" aria-controls={branch.FILIAL.replace(/ /g, "-").replace(/\./g, "-")} aria-selected="false">{branch.FILIAL}</button>
            </li>
          )
        })}
      </ul>
      <div className="tab-content" id="pills-tabContent">
        <div key={`tabcontent-0`} className="tab-pane fade show active" id="financial-dashboard-results" role="tabpanel" aria-labelledby="financial-dashboard-results-tab" tabIndex="0">
          <GeneralFinancialOverview
            isTabOpen={currentTab === `financial-dashboard-results-tab` ? true : false}
            filterData={filterData}
            currentXhr={currentXhr}
            setCurrentXhr={setCurrentXhr}
            onlyFranchise={onlyFranchise} />
        </div>
        {branches.length > 0 && branches.map((branch, index) => {
          return <div key={`tabcontent-${index + 1}`} className="tab-pane fade" id={branch.FILIAL.replace(/ /g, "-").replace(/\./g, "-")} role="tabpanel" aria-labelledby={branch.FILIAL.replace(/ /g, "-").replace(/\./g, "-") + '-tab'} tabIndex={index + 1}>
            <BranchFinancialOverview
              key={`tabcontainer-${index + 1}`}
              isTabOpen={currentTab === (branch.FILIAL.replace(/ /g, "-").replace(/\./g, "-") + '-tab') ? true : false}
              branchId={branch.ID}
              branch={branch.FILIAL}
              filterData={filterData}
              currentXhr={currentXhr}
              setCurrentXhr={setCurrentXhr} />
          </div>
        })}
      </div>
    </>
  )
};

try {
  if (document.getElementById('js-financial-dashboard-content')) {
    const container = document.getElementById('js-financial-dashboard-content');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<FinancialDashboard />);
  }
} catch (err) {
  console.error('Error rendering FinancialDashboard: ', err);
}